export const maxNotificationPeriodInDays = 90;

export interface ContractBasicInfo {
    id: string;
    name: string;
    startDate?: Date;
    endDate?: Date;
    businessAreaIds: Array<string>;
}

export enum RelativeDateUnit {
    Days = 0,
    Weeks = 1,
    Months = 2,
    Years = 3,
}

export enum RelativeDateDirection {
    Before = 0,
    After = 1,
}

export enum RelativeDateReference {
    ContractStart = 0,
    ContractEnd = 1,
}

export interface RelativeDateConfigModel {
    value: number;
    unit: RelativeDateUnit;
    direction: RelativeDateDirection;
    relativeTo: RelativeDateReference;
}
